import { UserTypes, useUsers } from "@/composables/users";
import {
  DashboardHeader,
  WhiteCard,
  UiButton,
  UserTable,
  UiSelect,
  UiModal,
} from "@/components";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { UserModel } from "@/app/entities";
import { useUserStore } from "@/context/stores/user.store";
import UserForm from "@/components/molecules/users/user.form";

export default function DashboardUsers() {
  const {
    loading,
    fetchUsers,
    removing,
    setCurrentType,
    setAvailableTypes,
    getAvailableTypes,
    userTypesOptions,
    open,
    setOpen,
    setIsEditing,
    removeUser,
  } = useUsers();

  const users = useUserStore.getState().users;
  const [typeToFetch, setTypeToFetch] = useState<UserTypes>("" as UserTypes);
  const [editingUser, setEditingUser] = useState<UserModel | null>(null);
  const [toDelete, setToDelete] = useState<string | null>(null);

  useEffect(() => {
    setAvailableTypes(getAvailableTypes());
    setCurrentType(UserTypes.PARTICULIER);
  }, []);

  useEffect(() => {
    doSearch();
  }, [typeToFetch]);

  const doSearch = (page?: number) => {
    fetchUsers({ page: page ? page - 1 : 0, type: typeToFetch });
  };

  const handleEdit = (user: UserModel): void => {
    setEditingUser(user);
    setIsEditing(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setIsEditing(false);
    setEditingUser(null);
  };

  const handleDelete = async (v: UserModel) => {
    setToDelete(v.matricule);
    await removeUser({ login: v.matricule, action: !v.disabled });
    doSearch();
  };

  const onModalClose = () => {
    doSearch();
    setOpen(false);
  };

  return (
    <>
      <DashboardHeader subTitle="Gestion des utilisateurs" />

      <div className="py-4">
        <WhiteCard
          styles={{ borderRadius: "30px" }}
          headerSlot={
            <div className="flex items-center justify-between">
              <UiButton
                className="normal-case"
                onClick={() => setOpen(true)}
                startIcon={<Plus />}
              >
                Ajouter un utilisateur
              </UiButton>

              <div className="flex items-start gap-4">
                <div className="flex items-center gap-1">
                  <label className="text-xs label-gray">
                    Type d'utilisateur :{" "}
                  </label>
                  <UiSelect
                    defaultValue={typeToFetch}
                    onChange={(v) => setTypeToFetch(v as UserTypes)}
                    options={userTypesOptions}
                    styles={{ width: "150px" }}
                  ></UiSelect>
                </div>
              </div>
            </div>
          }
        >
          <div className="py-6">
            <UserTable
              users={users}
              loading={loading}
              deleting={removing}
              matricule={toDelete || undefined}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onAddUser={() => {}}
              onPageChange={(v) => doSearch(v)}
              onPageSizeChange={(v) => doSearch(1)}
            />
          </div>
        </WhiteCard>
      </div>

      <UiModal
        title={
          editingUser ? "Modifier un utilisateur" : "Ajouter un utilisateur"
        }
        onClose={handleClose}
        visible={open}
        maxWidth="md"
      >
        <UserForm initialValue={editingUser} onClose={onModalClose} />
      </UiModal>
    </>
  );
}
